/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 18/8/2023
 */

import React, {useEffect, useState} from "react";
import TimeoutWarningDialog from "./TimeoutWarningDialog";
import { addEventListeners, removeEventListeners } from "../../Utils/eventListener";
import { logout } from "../../Store/Slices/authSlice";
import { useDispatch } from "react-redux";

export const SessionTimeout = () => {
    const [isWarningModalOpen, setWarningModalOpen] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        const createTimeout1 = () => setTimeout(()=>{
            setWarningModalOpen(true);
        },30*60*1000)

        const createTimeout2 = () => setTimeout(() => {
            dispatch(logout());
            window.location.reload();
        },60*1000)

        const listener = () => {
            if(!isWarningModalOpen){
                clearTimeout(timeout)
                timeout = createTimeout1();
            }
        }

        // Initialization
        let timeout = isWarningModalOpen ? createTimeout2() : createTimeout1()
        addEventListeners(listener);

        // Cleanup
        return () => {
            removeEventListeners(listener);
            clearTimeout(timeout);
        }
    },[isWarningModalOpen])

    return (
        <div>
            {isWarningModalOpen && (
                <TimeoutWarningDialog
                    open={isWarningModalOpen}
                    onClose={() => setWarningModalOpen(false)}
                />
                )
            }
        </div>
    )
}